import { YamlComponent } from "./../yaml/yaml.component";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "nw-code",
  templateUrl: "./code.component.html",
  styleUrls: ["./code.component.css"],
})
export class CodeComponent extends YamlComponent implements OnInit {}
